import { render, staticRenderFns } from "./BeCard.vue?vue&type=template&id=6d9a0c97&"
import script from "./BeCard.vue?vue&type=script&lang=js&"
export * from "./BeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports